import { useParams } from 'react-router-dom'

import { useTranslation } from '../../i18n/hooks'

export const usePolicyId = () => {
  const translate = useTranslation()
  const params = useParams()
  const ecomPolicyId = Number(params.ecomPolicyId)

  if (isNaN(ecomPolicyId)) throw Error(translate('Policy ID is not a number!'))
  return ecomPolicyId
}
